import type { CronJob } from './smarttime.classes.cronjob.js';

/**
 * the cron jobs of a CronManager, backed by a platform Set;
 * keeps smarttime free of a dependency on @push.rocks/lik
 */
export class CronJobCollection implements Iterable<CronJob> {
  private cronJobSet = new Set<CronJob>();

  public add(cronJobArg: CronJob): void {
    this.cronJobSet.add(cronJobArg);
  }

  public remove(cronJobArg: CronJob): void {
    this.cronJobSet.delete(cronJobArg);
  }

  /**
   * a snapshot of the jobs; adding or removing jobs later does not change it
   */
  public getArray(): CronJob[] {
    return [...this.cronJobSet];
  }

  public isEmpty(): boolean {
    return this.cronJobSet.size === 0;
  }

  public get length(): number {
    return this.cronJobSet.size;
  }

  public [Symbol.iterator](): Iterator<CronJob> {
    return this.cronJobSet.values();
  }
}
